// buffs are free power-ups
export const FREE_ENERGY_RECHARGE_COOLDOWN = 1000 * 60 * 60 * 8; // 8 hours in ms
export const FREE_ROCKETMAN_USES = 1000 * 60 * 60 * 8; // 8 hours in ms

export type Buff =
  | 'Rocketman'
  | 'FullEnergy'
  | 'AutoBotReward'
  | 'AutoBotFirstSession';
